import { useMemo } from 'react'

import { Flex } from 'antd'
import { Tooltip } from 'govwell-ui'
import { CodeBookItemFragment } from 'types/graphql'

import { FormSelectLoadingPlaceholder } from 'src/components/form/shared/LoadingPlaceholder'
import Text, { TextSize } from 'src/components/Typography/Text'
import { useCodeBookItemsByIdsQuery } from 'src/fetch/codeBookItems'

type Props = {
  codeBookItemIds: number[]
  size?: TextSize
}
const CodeBookItemFieldDisplay = ({ codeBookItemIds, size }: Props) => {
  // Resolve by id (no archive filter) so saved values still render after their
  // book is archived. Scanning the active codeBooks query would drop them.
  const { data: codeBookItemsQuery, isLoading: isLoadingCodeBookItems } =
    useCodeBookItemsByIdsQuery(codeBookItemIds)
  const codeBookItemsById = useMemo(
    () =>
      new Map<number, CodeBookItemFragment>(
        codeBookItemsQuery?.codeBookItemsByIds.map((cbi) => [cbi.id, cbi])
      ),
    [codeBookItemsQuery?.codeBookItemsByIds]
  )

  if (isLoadingCodeBookItems) {
    return <FormSelectLoadingPlaceholder />
  }
  return (
    <Flex vertical>
      {codeBookItemIds.map((id) => (
        <Tooltip content={codeBookItemsById.get(id)?.text} key={id}>
          <Text size={size}>{codeBookItemsById.get(id)?.formattedName}</Text>
        </Tooltip>
      ))}
    </Flex>
  )
}

export default React.memo(CodeBookItemFieldDisplay)
